import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { SmartSafe } from '@app/shared/models/smartsafe/smartsafe.model';
import { SmartSafeStatus } from '@app/shared/models/smartsafe/smartsafe-status.model';


@Component({
    selector: 'app-smartsafe-card',
    templateUrl: './smartsafe-card.component.html',
    styleUrls: ['./smartsafe-card.component.css'],
    standalone: false
})
export class SmartSafeCardComponent implements OnInit, OnDestroy {
    @Input() smartsafe: SmartSafe;
    @Input() smartsafeStatus: SmartSafeStatus;

    constructor() {}

    ngOnInit() {}
    ngOnDestroy() {}


}